(() => {
  const callback = () => {
    const selectors = {
      cartDrawer: '#CartDrawer',
      cartDrawerLoader: '.drawer__loading',
      cartCheckoutButton: '.cart__checkout',
      cartItemsContainer: '.cart__items',
      cartItem: '.cart__item',
      cartItemRemoveButton: '.cart__item-remove-button',
      setItemsContainer: '.cart-set__items',
      setInfoSavingsPercent: '.cart-set__info span',
      setInfoSubtotal: '.cart-set__subtotal-price',
    };

    const cartDrawer = document.querySelector(selectors.cartDrawer);
    if (!cartDrawer) return;

    const groupItemsIntoSets = () => {
      const { locale, is_savings_enabled: isSavingsEnabled } = window.themeComponents.snippets['cart-drawer'] ?? {};

      const cartItemsContainer = cartDrawer.querySelector(selectors.cartItemsContainer);
      const cartItems = cartDrawer.querySelectorAll(selectors.cartItem);
      const sets = [];

      if (!cartItemsContainer || !cartItems) return;

      cartItems.forEach((item) => {
        const styleTag = item.dataset.style;
        if (!styleTag) return;

        const existingSetIndex = sets.findIndex((set) => {
          const hasMatchingStyle = set.styleTag === styleTag;
          const isItemTypeUnique = set.items.every((setItem) => setItem.dataset.itemType !== item.dataset.itemType);

          return hasMatchingStyle && isItemTypeUnique;
        });

        if (existingSetIndex !== -1) {
          sets[existingSetIndex] = { ...sets[existingSetIndex], items: [...sets[existingSetIndex].items, item] };
        } else {
          sets.push({
            styleTag,
            styleName: styleTag.replace('style-', ''),
            items: [item],
          });
        }
      });

      const container = document.createElement('div');
      sets.forEach((set) => {
        // Skip set if it consists of only one product
        if (set.items.length < 2) return;

        const template = document.createElement('div');
        template.innerHTML = `
          <div class="cart-set" data-set="${set.styleTag}">
            <div class="cart-set__inner">
              <div class="cart-set__title">${set.styleName} ${locale.set}</div>

              ${isSavingsEnabled ? `<div class="cart-set__info">${locale.save} <span></span>% ${locale.by}</div>` : ''}

              <div class="cart-set__items"></div>

              <div class="cart-set__subtotal">
                <div class="cart-set__subtotal-text">${locale.subtotal}</div>
                <div class="cart-set__subtotal-price"></div>
              </div>
            </div>
          </div>
        `;

        let subtotal = 0;
        const setItemsContainer = template.querySelector(selectors.setItemsContainer);

        set.items.forEach((item) => {
          subtotal += Number(item.dataset.finalPrice) * Number(item.dataset.quantity);
          setItemsContainer.append(item);
        });

        const percentElement = template.querySelector(selectors.setInfoSavingsPercent);
        if (percentElement) percentElement.innerHTML = set.items[0].dataset.setDiscountPercent;

        const subtotalElement = template.querySelector(selectors.setInfoSubtotal);
        if (subtotalElement) subtotalElement.innerHTML = theme.Currency.formatMoney(subtotal);

        container.append(template);
      });

      cartItemsContainer.append(container);
    };

    const removeCartItem = async ({ id }) => {
      if (!id) return;

      try {
        togglePreloader({ show: true });

        const request = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ quantity: 0, id: id.toString() }),
        });

        if (request.ok) {
          // Rebuild the cart
          document.dispatchEvent(new Event('ajaxProduct:removed', { bubbles: true }));
        }
      } catch (error) {
        togglePreloader({ show: false });
        console.error(error);
      }
    };

    cartDrawer.addEventListener('click', (event) => {
      const removeBtn = event.target.closest(selectors.cartItemRemoveButton);
      if (removeBtn) {
        event.preventDefault();
        removeCartItem({ id: removeBtn.dataset.lineItemKey });
      }

      const checkoutBtn = event.target.closest(selectors.cartCheckoutButton);
      if (checkoutBtn) {
        document.dispatchEvent(new CustomEvent('checkout:started'));
      }
    });

    const togglePreloader = ({ show }) => {
      const preloader = cartDrawer.querySelector(selectors.cartDrawerLoader);
      preloader?.toggleAttribute('hidden', !show);
    };

    document.addEventListener('cart:markup-built', groupItemsIntoSets);
    document.addEventListener('cart:preloader-triggered', () => togglePreloader({ show: true }));
    document.addEventListener('cart:markup-built', () => togglePreloader({ show: false }));
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
